<template>
  <el-dialog
    v-model="dialogVisible"
    append-to-body
    class="link-exisiting-lark-dialog"
    :close-on-click-modal="false"
    destroy-on-close
    :show-close="false"
    :width="600"
  >
    <template #header>
      <div class="link-exisiting-lark-dialog__header">
        <div class="link-exisiting-lark-dialog__title">{{ title }}</div>
        <button
          class="link-exisiting-lark-dialog__close"
          type="button"
          @click="dialogVisible = false"
        >
          <i class="icon-close-large-line t-iconfont"></i>
        </button>
      </div>
    </template>

    <div class="link-exisiting-lark-dialog__body">
      <div class="link-exisiting-lark-dialog__field">
        <div class="link-exisiting-lark-dialog__label">飞书群聊会话 ID</div>
        <el-input
          v-model="formData.chatId"
          class="link-exisiting-lark-dialog__input-text"
          placeholder="请输入会话 ID，确定后系统将自动拉取飞书机器人加入该群聊"
        />
      </div>

      <button class="link-exisiting-lark-dialog__help" type="button" @click="handleHelpClick">
        如何获取群聊会话 ID？
      </button>
    </div>

    <template #footer>
      <div class="link-exisiting-lark-dialog__footer">
        <el-button @click="dialogVisible = false"> 取消 </el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleConfirm">
          确定关联
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script setup>
import { computed, reactive, ref, watch } from 'vue'
import AppMessage from '@/components/message/index.js'
import { bindLarkGroup } from '@/api/ai-board'
import { ElMessage } from 'element-plus'

defineOptions({
  name: 'LinkExisitingLarkDialog'
})

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: '关联已有群聊'
  },
  dataId: {
    type: [String, Number],
    default: ''
  },
  businessType: {
    type: [String, Number],
    default: ''
  }
})

const emits = defineEmits(['update:modelValue', 'success', 'help'])

const dialogVisible = computed({
  get: () => props.modelValue,
  set: (value) => emits('update:modelValue', value)
})

const formData = reactive({
  chatId: ''
})
const submitLoading = ref(false)

const resetForm = () => {
  formData.chatId = ''
}

watch(
  () => dialogVisible.value,
  (visible) => {
    if (visible) {
      resetForm()
    }
  }
)

const handleConfirm = async () => {
  if (submitLoading.value) return
  const groupId = formData.chatId.trim()
  if (!groupId) {
    ElMessage.warning({
      message: '请输入群聊会话 ID',
      duration: 1000
    })
    return
  }

  submitLoading.value = true
  try {
    const res = await bindLarkGroup({
      dataId: props.dataId,
      businessType: props.businessType,
      groupId
    })

    if (res.result.isSuccess === 1) {
      AppMessage.success('关联成功')
      dialogVisible.value = false
      emits('success')
    } else if (res.result.isSuccess === 0) {
      AppMessage.error('关联失败，请重试')
    }
  } catch (error) {
    // AppMessage.error('关联失败，请重试')
  } finally {
    submitLoading.value = false
  }
}

const handleHelpClick = () => {
  emits('help')
}
</script>

<style lang="scss">
.link-exisiting-lark-dialog {
  margin-top: 15vh;
  border-radius: 12px;
  box-shadow: 0px 2px 15px 2px rgba(0, 0, 0, 0.05);
}

.link-exisiting-lark-dialog .el-dialog__header {
  border-bottom: none;
}

.link-exisiting-lark-dialog .el-dialog__body {
  padding: 0;
}

.link-exisiting-lark-dialog .el-dialog__footer {
  padding: 0;
  height: unset;
  border-top: none;
}
</style>

<style lang="scss" scoped>
.link-exisiting-lark-dialog__header {
  display: flex;
  align-items: center;
  padding: 24px;
}

.link-exisiting-lark-dialog__title {
  flex: 1;
  font-family: PingFang SC;
  font-size: 18px;
  font-weight: 600;
  line-height: 26px;
  color: #323233;
}

.link-exisiting-lark-dialog__close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  margin-left: 8px;
  font-size: 16px;
  color: #969799;
  background: transparent;
  border: none;
  cursor: pointer;
}

.link-exisiting-lark-dialog__body {
  display: flex;
  flex-direction: column;
  padding: 0 24px;
  font-family: PingFang SC;
}

.link-exisiting-lark-dialog__field {
  display: flex;
  flex-direction: column;
}

.link-exisiting-lark-dialog__label {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #323233;
}

.link-exisiting-lark-dialog__input-text {
  margin-top: 8px;
}

.link-exisiting-lark-dialog__input-text :deep(.el-input__wrapper) {
  min-height: 32px;
  background: #ffffff;
  border: 1px solid #e5e6eb;
  border-radius: 8px;
  box-shadow: none;
}

.link-exisiting-lark-dialog__input-text :deep(.el-input__inner) {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #323233;
}

.link-exisiting-lark-dialog__help {
  width: fit-content;
  padding: 0;
  margin-top: 8px;
  font-size: 13px;
  font-weight: 400;
  line-height: 18px;
  color: #7a52f4;
  background: transparent;
  border: none;
  cursor: pointer;
}

.link-exisiting-lark-dialog__footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 20px 24px;
}
</style>
